import { render, staticRenderFns } from "./assays-view-batch-modal.vue?vue&type=template&id=5f997904&scoped=true&"
import script from "./assays-view-batch-modal.ts?vue&type=script&lang=ts&"
export * from "./assays-view-batch-modal.ts?vue&type=script&lang=ts&"
import style0 from "./assays-view-batch-modal.scss?vue&type=style&index=0&id=5f997904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f997904",
  null
  
)

export default component.exports